"use strict";
export enum AnimationTypes {
    SPINNER = "spinner",
    WAVE = "waves",
}

